import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading, authError, reloadProfile } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="h-10 w-10 rounded-full border-4 border-emerald-200 border-t-[#10B981] animate-spin" />
      </div>
    );
  }

  // Firebase oturumu var ama profil geçici olarak alınamadı (5xx/ağ/cold-start):
  // kullanıcıyı login'e ATMA — tekrar deneme imkanı ver (F1).
  if (authError) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[#F8FAFC] px-6 text-center">
        <p className="max-w-sm text-slate-600">
          Sunucuya şu anda ulaşılamıyor. Bağlantınızı kontrol edip tekrar deneyin.
        </p>
        <button
          onClick={() => reloadProfile()}
          className="rounded-xl bg-[#10B981] px-5 py-2.5 font-semibold text-white hover:bg-[#0EA371]"
        >
          Tekrar dene
        </button>
      </div>
    );
  }

  if (!user) {
    // Tam yolu sakla (query + hash dahil) ki giriş sonrası derin linke geri dönülsün (F13).
    return <Navigate to="/giris" state={{ from: location.pathname + location.search + location.hash }} replace />;
  }

  if (role && user.role !== role) {
    return <Navigate to="/" replace />;
  }

  return children;
}
